// Module
var code = `<button class="btn btn-primary" ng-click="\$ctrl.nuevo()"> <span>Nuevo</span> </button> <button class="btn btn-primary" ng-click="\$ctrl.refresh()"> <span>refresh</span> </button> `;
// Exports
module.exports = code;